<template>
    <div class=" my">
        <nav-bar title="活动人员"
                 left-text="返回"
                 left-arrow
                 @click-left="onClickLeft"
                 class="my-nav">
        </nav-bar>
        <div style="margin-top: 2.9rem"></div>

        <cell-group :title="'报名人数：'+ Number(list.length===0?0:list.length)">
            <cell v-for="(v,i) in list" :key="i"
                  :title="v.userName">
                <div slot="right-icon" style="display: flex;justify-content: center">
                    {{v.phone}}
                    <a :href="'tel:'+v.phone" style="margin-left: 0.5rem">
                        <icon name="phone-circle" size="25px" color="dodgerblue"/>
                    </a>
                </div>
                <div slot="label" >
                    <div style="width: 100%;overflow: hidden;
                        text-overflow:ellipsis;
                        white-space: nowrap;">{{v.company}}</div>
                    <div>{{v.department}}</div>
                </div>
            </cell>
        </cell-group>
        <!-- 分页-->
        <pagination v-model="page" :total-items="total" mode="simple" @change="init()" v-if="list.length"/>
        <empty v-else description="暂无数据"/>
    </div>
</template>

<script>
    import {
        Cell, CellGroup, NavBar, Divider,
        Button, Form, Field, DatetimePicker,
        Popup, Toast, Collapse, CollapseItem,
        Col, Row, Pagination, Dialog, Icon, SwipeCell, Empty
    } from 'vant'
    import service from "../../api/service";
    //
    export default {
        name: "applicants",
        components: {
            Cell,
            CellGroup,
            NavBar,
            Divider,
            AntButton: Button,
            AntForm: Form,
            AntField:
            Field,
            DatetimePicker,
            Popup,
            Collapse,
            CollapseItem,
            AntCol: Col,
            AntRow: Row,
            Pagination,
            Dialog,
            Icon, SwipeCell, Empty
        },
        data() {
            return {
                list: [],
                total: 0,
                page: 1,
            }
        },
        mounted() {
            this.init()
        },
        methods: {
            init() {
                service.get('/api/activity-creation-approval/findbaoming',
                    {
                        activityId: this.$route.query.id,
                        page:this.page
                    }).then(res => {
                    if (res.status === 200) {
                        this.list = res.data
                        this.total = res.total
                    }
                })
            },
            //返回
            onClickLeft() {
                this.$router.push({path: this.$route.query.url})
            }
        },

    }
</script>

<style scoped>
    .my {
        background-color: #f7f8fa;
        min-height: 100vh;
    }

</style>